export const UNSAVED_QUIZ_MESSAGE =
  "Masz wpisane odpowiedzi, których jeszcze nie sprawdzono ani nie zapisano. " +
  "Jeśli teraz wyjdziesz, utracisz je.";

const dirtyAttempts = new Set();
const confirmationHandlers = new Map();

export function setQuizAttemptDirty(attemptId, isDirty) {
  if (isDirty) {
    dirtyAttempts.add(attemptId);
  } else {
    dirtyAttempts.delete(attemptId);
  }
}

export function clearQuizAttemptDirty(attemptId) {
  dirtyAttempts.delete(attemptId);
  confirmationHandlers.delete(attemptId);
}

export function setQuizAttemptConfirmationHandler(attemptId, handler) {
  if (typeof handler === "function") {
    confirmationHandlers.set(attemptId, handler);
  } else {
    confirmationHandlers.delete(attemptId);
  }
}

export function hasUnsavedQuizAttempt() {
  return dirtyAttempts.size > 0;
}

export async function confirmUnsavedQuizNavigation(confirmFn) {
  if (!hasUnsavedQuizAttempt()) return true;

  if (confirmFn) {
    return Boolean(await confirmFn(UNSAVED_QUIZ_MESSAGE));
  }

  const modalHandler = Array.from(dirtyAttempts)
    .reverse()
    .map((attemptId) => confirmationHandlers.get(attemptId))
    .find((handler) => typeof handler === "function");

  if (modalHandler) {
    return Boolean(await modalHandler());
  }

  return window.confirm(UNSAVED_QUIZ_MESSAGE);
}

export function resetUnsavedQuizGuardForTests() {
  dirtyAttempts.clear();
  confirmationHandlers.clear();
}
